module.exports = __webpack_public_path__ + "img/stamp.3b20586.svg";